import request from '@/util/request';
import qs from 'qs';

export const getUserList = (params, options) =>
request.get('/mqtt/user/page', Object.assign({}, options, { params }));

export const addUser = (params, options) =>
request.post('/mqtt/user/add', params,options);

export const getUserDetail = (params, options) =>
request.get('/mqtt/user/detail', Object.assign({}, options, { params }));

export const removeUser = (params, options) =>
request.post('/mqtt/user/remove', qs.stringify(params),options);


export const updateUser = (params, options) =>
request.post('/mqtt/user/update', params,options);
